module.exports = __webpack_public_path__ + "img/Logo.1b4cf1b8.svg";